module.exports = __webpack_public_path__ + "static/media/Login-doDeploy2021.6bbe638c.png";